module.exports = "<section\n  class=\"file-drop\"\n  [ngClass]=\"{'drag-active': dragActive}\"\n  catFileDropZone\n  (fileDrop)=\"onFileDrop($event)\"\n  (dragover)=\"onDragEnter($event)\"\n  (dragleave)=\"onDragLeave($event)\"\n>\n  <ng-content></ng-content>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-form/components/input-file/input-file.component.html
// module id = ../../../../../src/app/modules/ui-form/components/input-file/input-file.component.html
// module chunks = main